<div class="top-section">
    <h6 class="heading mb-0 truncate">{{ ss.t(timers.length === 1 ?
        'habitTimeTypeNotification_timerRunning' : 'habitTimerTypeTimerRunning_titleTopBar') }}</h6>
    <app-svg name="close" class="ri-ms-6" role="button" (click)="dialogRef.close()" width="24px"
        height="24px"></app-svg>
</div>

<div class="body-section position-relative">
    <div class="timer-item ri-p-4" *ngFor="let timer of timers()" role="button" (click)="openHabit(timer)">
        <p class="text-16-400 color-8 mb-0">{{ habitStore.idToSetup()[timer.setupId].title }}</p>
        <div class='timer-progress-bar' *ngIf="timer.totalSeconds">
            <div class='progress-status' [style.width.%]="getPercentage(timer)"></div>
        </div>
        <p class="text-14-400 color-35 mb-0 ri-pt-2">{{ timer.totalSecondsSpent | parseSeconds }} <span  *ngIf="timer.totalSeconds" class="color-8">/ {{ getTotalSeconds(timer) | parseSeconds }}</span></p>
    </div>
</div>